import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";

import { SettingsContext } from "../../Context";
import { UserManagementActivationStatus } from "../../types";
import { GET_API_KEY_GROUPS } from "./gql";
import { ApiKeyGroupMappingEntity, ApiKeyGroupMappingStatus } from "./types";

type UseGetApiKeyGroupsProps = {
  apiKeyTeams: string[];
};

const useGetApiKeyGroups = ({ apiKeyTeams }: UseGetApiKeyGroupsProps) => {
  const { activationStatus } = useTypedContext(SettingsContext);

  const { data, loading, error } = useQuery(GET_API_KEY_GROUPS, {
    skip: !apiKeyTeams.length || activationStatus !== UserManagementActivationStatus.ACTIVE,
  });

  const groups: ApiKeyGroupMappingEntity[] = useMemo(() => {
    return apiKeyTeams.map((team) => {
      const group = data?.managedUserGroups.find((group) => group.groupName === team);

      return {
        id: group?.id || `unmapped-${team}`,
        description: group?.description || "",
        groupName: team,
        status:
          team === group?.groupName
            ? ApiKeyGroupMappingStatus.MAPPED
            : ApiKeyGroupMappingStatus.UNMAPPED,
      };
    });
  }, [data?.managedUserGroups, apiKeyTeams]);

  return { groups, loading, error };
};

export default useGetApiKeyGroups;
